module.exports = __webpack_public_path__ + "img/zhongmeishengwu.f41820ce.png";